export function headerReducer (state = {header: [], error: null}, action) {
  switch (action.type) {
    case 'LOAD_HEADER_START':
      return {
        ...state,
        error: null
      }
    case 'LOAD_HEADER_SUCCESS':
      return {
        ...state,
        header: action.payload
      }
    case 'LOAD_HEADER_ERROR':
      return {
        ...state,
        error: action.payload,
        header: []
      }
    default:
      return state;
  }
}

export default headerReducer;



// WEBPACK FOOTER //
// ./src/reducers/header.js